var map = {
	"./benefits.png": 2888,
	"./bills.png": 64672,
	"./charity.png": 62958,
	"./clothes.png": 30726,
	"./clothing.png": 45664,
	"./coffee.png": 30916,
	"./coffees.png": 82037,
	"./creditcards.png": 67894,
	"./dark_excludedfromanalysisicon.png": 58614,
	"./debts.png": 87600,
	"./drinks.png": 31413,
	"./eatingout.png": 13104,
	"./education.png": 49768,
	"./entertainment.png": 85852,
	"./essentials.png": 20495,
	"./family.png": 73036,
	"./fitness.png": 67106,
	"./future.png": 3093,
	"./gambling.png": 24937,
	"./general.png": 72038,
	"./gifts.png": 74283,
	"./groceries.png": 16491,
	"./health.png": 29130,
	"./hobbies.png": 23354,
	"./holiday.png": 17286,
	"./home&garden.png": 18468,
	"./home.png": 75341,
	"./income.png": 74861,
	"./insurance.png": 23426,
	"./insurances.png": 71603,
	"./insurnace.png": 94360,
	"./interest.png": 58286,
	"./internaltransfers.png": 31975,
	"./internaltransfersicon.png": 66708,
	"./investments.png": 3840,
	"./largepurchases.png": 33835,
	"./lifestyle.png": 45959,
	"./medical.png": 25923,
	"./mortgage.png": 33658,
	"./other.png": 26488,
	"./pension in.png": 34287,
	"./pension out.png": 6768,
	"./pensionin.png": 43305,
	"./pensionout.png": 13982,
	"./pets.png": 43634,
	"./plus.png": 72792,
	"./rent.png": 70169,
	"./resources.png": 36129,
	"./salary.png": 29726,
	"./savings.png": 6519,
	"./selfcare.png": 44765,
	"./shopping.png": 23840,
	"./socialising.png": 11561,
	"./sports and fitness.png": 88386,
	"./sportsandfitness.png": 99044,
	"./takeaways.png": 53448,
	"./tick.png": 35163,
	"./transfers.png": 22394,
	"./transport.png": 32177,
	"./travel.png": 52908,
	"./uncategorised.png": 89969,
	"./vehicle.png": 23706,
	"./withdrawals-1.png": 10716,
	"./withdrawals.png": 54246,
	"./work.png": 11575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79555;